// extracted by mini-css-extract-plugin
module.exports = {"className":"VenueHighlights--className","highlight":"VenueHighlights--highlight","icon":"VenueHighlights--icon","label":"VenueHighlights--label"};